module.exports = __webpack_public_path__ + "img/activation2.77809891.svg";